export const strings = {
  title: 'طباعة الشهادات',
  subtitle: 'شهادات برنامج تدريبي، ومن صدرت لهم',
  downloadCertificates: 'تحميل الشهادات',
  downloadList: 'تحميل قائمة المستخدمين',
  chooseProgram: 'اختر برنامجًا لعرض من صدرت لهم شهاداته',
  empty: 'لا توجد شهادات مطابقة',
  actionFailed: 'تعذر إتمام العملية',

  filter: {
    program: 'البرنامج التدريبي',
    from: 'من تاريخ',
    to: 'إلى تاريخ',
  },

  columns: {
    username: 'اسم المستخدم',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    group: 'الإدارة',
    issuedOn: 'تاريخ الإصدار',
    expiresOn: 'تاريخ الانتهاء',
    daysLeft: 'المتبقي',
  },
}
